export default __webpack_public_path__ + "assets/marker-icon.2b3e1faf.png";